/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListDeviceIntegrationSchedulesSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ListDeviceIntegrationSchedulesRequest = {
  /**
   * Provider identifier (e.g. jamf, kandji, drata, vanta).
   */
  provider: string;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListDeviceIntegrationSchedulesSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListDeviceIntegrationSchedulesSecurity$outboundSchema:
  z.ZodMiniType<
    ListDeviceIntegrationSchedulesSecurity$Outbound,
    ListDeviceIntegrationSchedulesSecurity
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.optional(z.string()),
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listDeviceIntegrationSchedulesSecurityToJSON(
  listDeviceIntegrationSchedulesSecurity:
    ListDeviceIntegrationSchedulesSecurity,
): string {
  return JSON.stringify(
    ListDeviceIntegrationSchedulesSecurity$outboundSchema.parse(
      listDeviceIntegrationSchedulesSecurity,
    ),
  );
}

/** @internal */
export type ListDeviceIntegrationSchedulesRequest$Outbound = {
  provider: string;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListDeviceIntegrationSchedulesRequest$outboundSchema:
  z.ZodMiniType<
    ListDeviceIntegrationSchedulesRequest$Outbound,
    ListDeviceIntegrationSchedulesRequest
  > = z.pipe(
    z.object({
      provider: z.string(),
      gramKey: z.optional(z.string()),
      gramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramKey: "Gram-Key",
        gramSession: "Gram-Session",
      });
    }),
  );

export function listDeviceIntegrationSchedulesRequestToJSON(
  listDeviceIntegrationSchedulesRequest: ListDeviceIntegrationSchedulesRequest,
): string {
  return JSON.stringify(
    ListDeviceIntegrationSchedulesRequest$outboundSchema.parse(
      listDeviceIntegrationSchedulesRequest,
    ),
  );
}
